import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel'
import React from 'react'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import FormCheckbox from 'components/Common/Inputs/FormControls/FormCheckbox'

const CustomerSubcontractCell = () => {
  return (
    <Grid container >
      <Grid item>
        <FormControlLabel
          control={
            <FormCheckbox name="is_contractor"/>
          }
          label="We subcontract for this general contractor"
        />
      </Grid>
    </Grid>
  )
}

export default CustomerSubcontractCell
